(function () {
  'use strict';

  angular
    .module('flightPaxCountReport')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('flightPaxCountReport', {
        url: '/flight-pax-count-report',
        views : {
        	'flightPaxCountReportView' : {
        		templateUrl: 'flight-pax-count-report/views/flight-pax-count-report.tpl.html',
                controller: 'FlightPaxCountReportCtrl',
                controllerAs: 'flightPaxCountReport'
        	}
        }
      });
  }
}());
